import React from 'react';
import img5 from '../../../assets/qa.png';
import img from '../../../assets/coding (2).png';
import img2 from '../../../assets/project (1).png';
import img3 from '../../../assets/technical-support.png';
import img4 from '../../../assets/system-integration.png';
import img6 from '../../../assets/adaptation (1).png';
import img7 from '../../../assets/responsibility.png';
import img8 from '../../../assets/salary.png';

//  Optimization: moved card content to a reusable array
const serviceData = [
  {
    img: img,
    title: "Development",
    desc: "We specialize in creating and optimizing high-quality, custom websites for businesses and organizations of all sizes, ensuring mobile-friendly and user-friendly solutions.",
    alt: "Custom web development for scalable and mobile-friendly solutions"
  },
  {
    img: img2,
    title: "Project Management",
    desc: "Our expert project management services ensure the timely and efficient delivery of software, while managing scope, cost, and resources effectively.",
    alt: "Expert project management for seamless software delivery"
  },
  {
    img: img3,
    title: "Technical Support",
    desc: "We offer domain registration, hosting services, and ongoing technical support to ensure your online presence remains secure and visible.",
    alt: "Reliable technical support for domain registration and hosting"
  },
  {
    img: img4,
    title: "System Integration",
    desc: "Our system integration service ensures the seamless connection of various software applications to optimize business operations.",
    alt: "System integration services for optimized IT solutions"
  },
  {
    img: img5,
    title: "Testing and QA",
    desc: "Our testing and QA services ensure that your products and applications meet the highest quality standards for reliability and performance.",
    alt: "Comprehensive testing and quality assurance services"
  },
  {
    img: img6,
    title: "Customization and Adaption",
    desc: "We provide tailored software solutions to meet the unique needs of your business, ensuring optimal performance and scalability.",
    alt: "Customized software solutions for specific business needs"
  },
  {
    img: img7,
    title: "Operations and Managed Services",
    desc: "We offer expert-managed services to streamline your operations, allowing you to focus on core business activities.",
    alt: "Managed services for streamlined business operations"
  },
  {
    img: img8,
    title: "Hiring and Payroll",
    desc: "We provide hassle-free hiring and payroll solutions, allowing businesses to focus on their growth while we handle the operational aspects.",
    alt: "Efficient hiring and payroll solutions for businesses"
  },
];

const Services = () => {
  return (
    <div id="services" className="bg-white pt-10 pb-7">
      <section className="max-w-screen-xl mx-auto px-4">
        {/*  Optimization: centralized container for consistent layout */}

        <div className="my-4 py-4">
          <h2 className="my-2 sm:text-4xl text-3xl text-[--bg-color] font-bold text-center" itemProp="name">
            Our Services
          </h2>

          <div className="flex justify-center">
            <div className="w-24 border-b-4 border-[--bg-color]"></div>
          </div>

          <p className="text-gray-600 text-center mt-6 mb-4 sm:px-0 px-4" itemProp="description">
            We are deeply committed to the growth and success of our clients through innovative and customized services.
          </p>
        </div>

        {/*  Optimization: merged both grids into one loop to avoid repetition */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {serviceData.map((service, index) => (
            <div
              key={index}
              className="bg-white transition-all ease-in-out duration-300 overflow-hidden rounded-lg shadow-xl p-3 group hover:bg-[#f4f4f4]"
              itemScope
              itemType="http://schema.org/Service"
            >
              <div className="m-2 text-sm">
                <img
                  alt={service.alt}
                  className="rounded-t group-hover:scale-[1.15] transition duration-700 ease-in-out h-[80px] m-auto mb-8 mt-3"
                  src={service.img}
                  itemProp="image"
                />
                <h3 className="mt-8 text-xl text-center font-semibold text-gray-900 mb-2" itemProp="name">
                  {service.title}
                </h3>
                <p className="text-gray-600 text-center" itemProp="description">
                  {service.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Services;
